import PropTypes from 'prop-types';
import React from 'react';
import EditorialCard from '../../../Community/EditorialCard/EditorialCard';
import { ARTICLES_CARD_PROPTYPES2 } from '../../../Includes/ArticleCardProps';
import ControlledWidthContainerEightHundred from '../../../Layout/ControlledWidthContainerEightHundred/ControlledWidthContainerEightHundred';

import './ArticleGrid.scss';

export default class ArticleGrid extends React.PureComponent {
    constructor(props) {
        super();
    }

    static propTypes = {
        title: PropTypes.string,
        content: PropTypes.arrayOf(PropTypes.shape(ARTICLES_CARD_PROPTYPES2))
            .isRequired,
    };

    static defaultProps = {};

    render() {
        return (
            <div className="component-CompanyPages-Sections-ArticleGrid">
                <ControlledWidthContainerEightHundred>
                    <div className="section-title">{this.props.title}</div>
                </ControlledWidthContainerEightHundred>
                <div className="grid-section">
                    {this.props.content.map((content, idx) => {
                        const sideClass = idx % 2 === 0 ? 'left' : 'right';
                        const image =
                            content.contentImage && content.contentImage.src
                                ? content.contentImage.src
                                : '';
                        return (
                            <div
                                key={content.title}
                                className={`articleColumnContainer ${sideClass}`}
                            >
                                <EditorialCard
                                    {...content}
                                    characterLimit={58}
                                    image={image}
                                />
                            </div>
                        );
                    })}
                </div>
                <div className="clear" />
            </div>
        );
    }
}
